import { motion } from "framer-motion";

export default function ThirdSection() {
  const handleCallClick = () => {
    window.location.href = "tel:+491734317404";
  };

  return (
    <div id="dienstleistungen" className="py-20 px-6 md:px-10">
      <div className="flex flex-col text-center gap-6 max-w-3xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-7xl text-darkBlue font-bold">
          Unsere Dienstleistungen
        </h2>
        <p className="text-gray-500 leading-relaxed">
          Wir sind Experten für nachhaltige Bau- und Infrastrukturprojekte. Seit
          2021 realisieren wir innovative Lösungen, die höchsten Ansprüchen an
          Qualität, Funktionalität und Umweltverträglichkeit gerecht werden.
        </p>
        <motion.button
          onClick={handleCallClick}
          className="px-8 py-3 bg-darkBlue rounded-lg self-center text-white font-medium hover:bg-blue-800 transition-colors"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Kontakt
        </motion.button>
      </div>
    </div>
  );
}
